module.exports = __webpack_public_path__ + "img/qidong.55ee09d1.svg";